import _get from 'lodash/get';
import { DocumentationBulkEditInputObject } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';
import { GetTaskGroupKey } from '../../utils/createTaskGroupKeyResolver';
import buildTaskGroupLinks from '../../utils/buildTaskGroupLinks';

type SelectOption = { value: string; label: string };
type LinkOption = SelectOption & { visibleViaQr?: boolean };

export default function prepareBulkEditData(
  values: Values,
  getTaskGroupKey?: GetTaskGroupKey,
): DocumentationBulkEditInputObject {
  const attributes: DocumentationBulkEditInputObject = {};

  const category = _get(values, DocumentFormFieldNames.Category) as
    SelectOption | undefined;
  if (category?.value) {
    attributes.categoryId = category.value;
  }

  const sectors = _get(values, DocumentFormFieldNames.Sectors) as
    SelectOption[] | undefined;
  if (sectors?.length) {
    attributes.sectorLinks = sectors.map((s) => ({ id: s.value }));
  }

  const sites = _get(values, DocumentFormFieldNames.Sites) as
    SelectOption[] | undefined;
  if (sites?.length) {
    attributes.siteLinks = sites.map((s) => ({ id: s.value }));
  }

  const approver = _get(values, DocumentFormFieldNames.Approver) as
    SelectOption | undefined;
  if (approver?.value) {
    attributes.approverId = approver.value;
  }

  const equipment = _get(values, DocumentFormFieldNames.Equipment) as
    LinkOption[] | undefined;
  if (equipment?.length) {
    attributes.assetLinks = equipment.map((e) => ({
      id: e.value,
      visibleViaQr: e.visibleViaQr ?? true,
    }));
  }

  const areas = _get(values, DocumentFormFieldNames.Areas) as
    LinkOption[] | undefined;
  if (areas?.length) {
    attributes.areaLinks = areas.map((a) => ({
      id: a.value,
      visibleViaQr: a.visibleViaQr ?? true,
    }));
  }

  const formTemplates = _get(values, DocumentFormFieldNames.FormTemplates) as
    SelectOption[] | undefined;
  if (formTemplates?.length) {
    attributes.formTemplateLinks = formTemplates.map((f) => ({ id: f.value }));
  }

  const taskGroupLinks = buildTaskGroupLinks({
    values: _get(values, DocumentFormFieldNames.Tasks) as
      SelectOption[] | undefined,
    getTaskGroupKey,
  });
  if (taskGroupLinks) attributes.taskGroupLinks = taskGroupLinks;

  return attributes;
}
